import React from 'react';
import { Button, ButtonText } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

type NeedHelpButtonProps = {
  onPress?: () => void;
  isPaused?: boolean;
  isRequestingHelp?: boolean;
};

/**
 * Single "Need help" affordance — parent wires to requestHelp (help_requested pause).
 */
export function NeedHelpButton({
  onPress,
  isPaused = false,
  isRequestingHelp = false,
}: NeedHelpButtonProps) {
  const { t } = useTranslation();

  if (!onPress) return null;

  return (
    <Button
      size="sm"
      variant="link"
      action="primary"
      onPress={onPress}
      isDisabled={isPaused || isRequestingHelp}
      accessibilityState={{ disabled: isPaused || isRequestingHelp }}
      testID="oral-exam-need-help"
    >
      <ButtonText>
        {t('oralExam.needHelp', { defaultValue: 'Need help' })}
      </ButtonText>
    </Button>
  );
}
